import type { ReactNode } from "react";
import { I } from "../ui";
import type { Route } from "./routes";

interface NavSection {
  id: string;
  section: string;
}

export interface NavLink {
  id: Route;
  label: string;
  icon: ReactNode;
  count?: number;
  section?: undefined;
}

export type NavEntry = NavSection | NavLink;

export type PageTitle = readonly [string, string];

export function navItemsFor({
  isAdmin,
  canManageOrg,
  onlineCount,
}: {
  isAdmin: boolean;
  canManageOrg: boolean;
  onlineCount: number;
}): NavEntry[] {
  const items: NavEntry[] = [
    { id: "section-work", section: "Lavoro" },
    { id: "dashboard", label: "Panoramica", icon: I.dash },
    // "lookup" (Indirizzo): screen legacy della fase Scraper AdE/atti, tolta
    // dal menu 2026-07-13. Route e API restano: raggiungibile via /lookup.
    { id: "necrologi", label: "Necrologi", icon: I.book },
    { id: "prospects", label: "Prospect", icon: I.layers },
    { id: "section-tools", section: "Strumenti" },
    { id: "extension", label: "Estensione Chrome", icon: I.session, count: onlineCount },
    // I membri vedono le fonti in sola lettura (Sources nasconde le azioni).
    { id: "sources", label: "Fonti necrologi", icon: I.database },
  ];

  if (isAdmin || canManageOrg) {
    items.push({ id: "section-admin", section: "Amministrazione" });
  }

  if (isAdmin) {
    items.push({ id: "users", label: "Utenti", icon: I.users });
  }

  if (isAdmin || canManageOrg) {
    items.push({ id: "orgs", label: "Aziende", icon: I.building });
  }

  return items;
}

const CRUMBS: Record<Route, string[]> = {
  dashboard: ["Lavoro", "Panoramica"],
  guida: ["Guida"],
  extension: ["Strumenti", "Estensione Chrome"],
  lookup: ["Strumenti", "Ricerca indirizzo"],
  necrologi: ["Lavoro", "Necrologi"],
  sources: ["Strumenti", "Fonti necrologi"],
  prospects: ["Lavoro", "Prospect"],
  users: ["Amministrazione", "Utenti"],
  orgs: ["Amministrazione", "Aziende"],
};

const PAGE_TITLES: Record<Route, PageTitle> = {
  dashboard: ["Panoramica", "Cosa c'è da fare oggi e come sta lavorando il sistema"],
  guida: ["Guida", "Procedure per utilizzare Legacy e l'estensione SISTER"],
  extension: [
    "Estensione Chrome",
    "Installa e abbina l'estensione che cerca le persone su SISTER",
  ],
  lookup: ["Ricerca indirizzo", "Ricerca catastale e stima dei tempi di acquisizione"],
  necrologi: ["Necrologi", "Passo 1: scegli chi cercare su SISTER"],
  sources: ["Fonti necrologi", "Siti da cui arrivano i necrologi e quando vengono letti"],
  prospects: ["Prospect", "Passi 3 e 4: controlla gli omonimi e invia a Herobot"],
  users: ["Utenti", "Account, ruoli e autorizzazioni"],
  orgs: ["Aziende", "Organizzazioni, membri e ruoli di accesso"],
};

export function crumbsForRoute(route: Route): string[] {
  return CRUMBS[route] ?? [route];
}

export function pageTitleForRoute(route: Route): PageTitle {
  return PAGE_TITLES[route] ?? ["—", ""];
}
